import { Component } from 'react';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { H2 } from 'foundations-components/transitional/components/H2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class ConversationMovedToTrash extends Component {
  render() {
    return /*#__PURE__*/_jsxs(Flex, {
      marginBlockStart: "1500",
      justifyContent: "start",
      alignItems: "center",
      flexDirection: "column",
      inlineSize: "100%",
      children: [/*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(Illustration, {
          name: "no-conversations",
          width: "200px"
        })
      }), /*#__PURE__*/_jsx(Box, {
        marginBlockStart: "600",
        children: /*#__PURE__*/_jsx(H2, {
          color: "icon-core-subtle",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-ui.conversationMovedToTrash.noLongerHere"
          })
        })
      }), /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx(Text, {
          color: "icon-core-subtle",
          typography: "body-200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-ui.conversationMovedToTrash.movedToTrash"
          })
        })
      }, 1)]
    });
  }
}
ConversationMovedToTrash.displayName = 'ConversationMovedToTrash';
export default ConversationMovedToTrash;